export default __webpack_public_path__ + "static/media/SOL.b612f140.svg";